import { useQuery } from "react-query";
import { firestore } from "@/services/firestore";
import { Shop } from "@/types/v2";

// The audit page searches and sorts in memory: Firestore has no substring
// search, and ordering by a field (createdAt) drops shops that lack it, which
// would hide shops from an audit. One read of the shops collection per visit
// is cheap for a superAdmin-only page.
export const useAllShops = () =>
  useQuery({
    queryKey: ["shop-config-audit-all-shops"],
    queryFn: () => firestore.listAllDocuments<Shop>("shops"),
    // Always re-read on mount: this is a verification tool, so a shop fixed
    // elsewhere must show as fixed when the operator comes back.
    refetchOnMount: "always",
    staleTime: 5 * 60 * 1000,
  });
